import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import ConfirmationFormComponent from "../../components/confirmationForm/confirmationForm";

export default function ConfirmationPage() {
    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <title>Account Confirmation | Prepal</title>
                <meta name="description" content="Confirm your Prepal account email verification to complete your registration." />
                <meta name="keywords" content="Prepal, email confirmation, account verification, test prep" />
                <meta name="author" content="Prepal Team" />
            </Helmet>
            <ConfirmationFormComponent />
        </>
    );
}